import { useMutation } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { gql } from 'graphql-tag';

import {
  AddTourTagMutation as AddTourTagMutationResult,
  RemoveTourTagMutation as RemoveTourTagMutationResult,
  AddTourTagMutationVariables,
  RemoveTourTagMutationVariables,
} from '../../lib/graphql';
import { tourQuery } from '../graphql';

const addTourTagMutation = gql`
  mutation AddTourTag($tour_id: String!, $tag_name: String!) {
    addTourTag(tour_id: $tour_id, tag_name: $tag_name)
  }
`;

const removeTourTagMutation = gql`
  mutation RemoveTourTag($tour_id: String!, $tag_name: String!) {
    removeTourTag(tour_id: $tour_id, tag_name: $tag_name)
  }
`;

export function useTourTagMutations() {
  const notify = useNotifications();
  const [addTourTagFn] = useMutation<AddTourTagMutationResult, AddTourTagMutationVariables>(addTourTagMutation);
  const [removeTourTagFn] = useMutation<RemoveTourTagMutationResult, RemoveTourTagMutationVariables>(
    removeTourTagMutation,
  );

  const addTourTag = async ({ variables }: { variables: AddTourTagMutationVariables }) => {
    const response = await addTourTagFn({
      variables,
      refetchQueries: [
        {
          query: tourQuery,
          variables: {
            tour_id: parseInt(variables.tour_id, 10),
          },
        },
      ],
    });
    notify.success({ title: 'Tour tag added' });
    return response;
  };

  const removeTourTag = ({ variables }: { variables: RemoveTourTagMutationVariables }) => {
    const response = removeTourTagFn({
      variables,
      refetchQueries: [
        {
          query: tourQuery,
          variables: {
            tour_id: parseInt(variables.tour_id, 10),
          },
        },
      ],
    });
    notify.success({ title: 'Tour tag removed' });
    return response;
  };

  return { addTourTag, removeTourTag };
}
